import { useEffect, useState } from 'react'

function detect() {
  if (typeof window === 'undefined') return false
  return (
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  )
}

export function useStandalone() {
  const [standalone, setStandalone] = useState(detect)

  useEffect(() => {
    if (!window.matchMedia) return
    const mq = window.matchMedia('(display-mode: standalone)')
    const handler = (e) => setStandalone(e.matches || window.navigator.standalone === true)

    if (mq.addEventListener) {
      mq.addEventListener('change', handler)
      return () => mq.removeEventListener('change', handler)
    }
    mq.addListener(handler)
    return () => mq.removeListener(handler)
  }, [])

  return standalone
}
